let scriptPromise = null;

/**
 * Loads the Google Maps script dynamically with the provided API key
 * @param {string} apiKey - The Google Maps API key
 * @returns {Promise} A promise that resolves when the script is loaded
 */
export const loadGoogleMaps = (apiKey) => {
  // If we already have a promise in progress, return it
  if (scriptPromise) {
    return scriptPromise;
  }
  // If the script is already loaded, return a resolved promise
  if (window.google?.maps?.Map) {
    return Promise.resolve();
  }

  scriptPromise = new Promise((resolve, reject) => {
    // Create the script element
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`;
    script.async = true;
    script.defer = true;

    // Set up load handler
    script.onload = () => {
      resolve();
    };

    // Set up error handler
    script.onerror = () => {
      scriptPromise = null; // Reset promise so we can try loading again
      reject(new Error('Failed to load Google Maps script'));
    };

    // Add the script to the document
    document.head.appendChild(script);
  });

  return scriptPromise;
};

